import { Model } from 'libx';
import { computed, observable, action } from 'mobx';
import { task } from 'mobx-task';

class TreeNode extends Model {

  @observable isExpanded = false;
  @observable isHovered = false;
  @observable isActive = false;
  @observable isLoadingChildren = false;
  @observable isLoading = false;
  @observable isFlashed = false;

  @computed
  get hasInfo() {
    return !!this.code;
  }

  @computed get isFinal() {
    return this.iscode;
  }

  @computed
  get parent() {
    return this.store.nodes.find(node => node.id === this.parentId);
  }

  @computed
  get children() {
    return this.store.nodes.orderBy('id', 'asc').filter(node => node.parentId === this.id);
  }

  @computed
  get path() {
    return this.parent ? `${this.parent.path}/${this.id}` : `/${this.id}`;
  }

  @computed
  get isTarget() {
    return this.isFinal || this.children.filter(node => node.isExpanded).length === 0;
  }

  @computed
  get branchIsExpanded() {
    return this.parent ? this.parent.branchIsExpanded && this.isExpanded : this.isExpanded;
  }

  @computed
  get needsToLoadChildren() {
    return !this.isLoadingChildren && !this.fetchChildNodes.resolved;
  }

  @action.bound
  setHovered(value) {
    this.isHovered = value;
    if (this.parent) {
      this.parent.setHovered(value);
    }
  }

  @action.bound
  restoreBranch() {
    return this.store.restoreNodeBranch(this.id);
  }

  @action.bound
  flash({ timeout = 500, count = 2, delay = 200, persist = false } = {}) {
    let counter = 0;

    const flash = (disableHide = false) => {
      this.isFlashed = true;
      if (!disableHide) {
        window.setTimeout(() => {
          this.isFlashed = false;
        }, timeout)
      }
    }

    window.setTimeout(() => {
      flash();
      const flashInterval = window.setInterval(() => {
        const isLast = ++counter === count - 1;
        if (isLast) window.clearInterval(flashInterval);
        flash(isLast);
      }, timeout * 2);
    }, delay);
  }

  @task
  async fetchChildNodes() {
    let result = this.children;

    if (this.needsToLoadChildren) {
      this.isLoadingChildren = true;
      result = await this.store.fetchChildNodes(this);
      this.isLoadingChildren = false;
    }

    return result;
  }

}

export default TreeNode;



// WEBPACK FOOTER //
// ./src/models/TreeNode.js